{% block prems_discount_promotion_selector_content %}
    <div class="sw-condition-line-item-in-category sw-condition__condition-value">
        <sw-entity-multi-select
            :label="$tc('prems-discount-category.detail.card.promotionRestriction.field.multiSelectText')"
            size="medium"
            entity="promotion"
            :entityCollection="promotions"
            @update:entity-collection="setPromotionIds"
        >
        </sw-entity-multi-select>
    </div>
{% endblock %}